import React from "react";

import { CloseIcon, CSVFileIcon } from "@atsent/components";
import { fileSize } from "lib/common";

export const FileTable = ({
  title,
  size,
  closeClick,
  state,
}: {
  title: string;
  size: number;
  closeClick: any;
  state: string;
}) => {
  return (
    <table className={"RemovableTable"}>
      <thead>
        <tr>
          <th>파일명</th>
          <th>용량</th>
          <th />
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div className="align">
              <CSVFileIcon />
              <span>{title}</span>
            </div>
          </td>
          <td>{fileSize(size)}</td>
          <td>
            <span className={"bold"}>{state}</span>
          </td>
          <td className={"align-right"}>
            <CloseIcon onClick={closeClick} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};
